// @ts-nocheck
import { createContext, useContext, useState } from "react";

const SubscriptionContext = createContext(null);

const SubscriptionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [step, setStep] = useState("Management");
  const [subscription, setSubscription] = useState(null);

  const contextValue = {
    subscription,
    step,
    setStep,
    setSubscription,
  };

  return (
    <SubscriptionContext.Provider value={contextValue}>{children}</SubscriptionContext.Provider>
  );
};

const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error("useSubscription must be used within a SubscriptionProvider");
  }
  return context;
};

export { SubscriptionProvider, useSubscription };
